import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { getTranslatedData } from '../data/translatedData';
import Header from './Header';
import Hero from './Hero';
import About from './About';
import Projects from './Projects';
import Experience from './Experience';
import Contact from './Contact';
import Footer from './Footer';

const AppContent: React.FC = () => {
  const { language, t } = useLanguage();
  const { personalInfo, skills, projects, experiences, education } = getTranslatedData(language, t);

  return (
    <>
      <Header />
      <Hero personalInfo={personalInfo} />
      <About skills={skills} />
      <Projects projects={projects} />
      <Experience experiences={experiences} education={education} />
      <Contact contactInfo={personalInfo.contact} />
      <Footer personalInfo={personalInfo} />
    </>
  );
};

export default AppContent;